import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageLineReport from '../../components/PageLineReport';

const SimpleQuote = () => {
    return <PageLineReport title="simplr-Quote" reportCode={ReportCodes.SimpleQuote} roundDigits percentage />;
};

export default SimpleQuote;
